module.exports = __webpack_public_path__ + "static/media/wandaPlusIcon.c0ded430.svg";